import { t } from '@lingui/macro';
import { searchFilterCopy } from './searchFilterCopy';
import { SingleSelectFilter, useSingleSelectFilter } from '../SingleSelectFilter';
const values = [
    {
        title: t({ message: 'Any', comment: 'Search filter: Search-type modifier' }),
        id: 'any',
    },
    {
        title: t({ message: 'All', comment: 'Search filter: Search-type modifier' }),
        id: 'all',
    },
    {
        title: t({ message: 'Phrase', comment: 'Search filter: Search-type modifier' }),
        id: 'phrase',
    },
    {
        title: t({ message: 'Exact name', comment: 'Search filter: Search-type modifier' }),
        id: 'exactName',
    },
];
export function SearchTypeFilter() {
    const filter = useSingleSelectFilter({
        paramKey: 'searchType',
        items: values,
        name: searchFilterCopy.searchType,
    });
    return <SingleSelectFilter filter={filter}/>;
}
